import React from 'react';
import { TableCell, TableHead, TableRow } from '@mui/material';
import './tableHeader.scss';
import useTranslate from '../../../customHooks/useTranslate';

const TableHeader = ({ columns, order, sort, isLoading, canSearch }) => {
    const translate = useTranslate();
    const { field: prevField, dir: prevDir } = order;

    const handleSort = (isSortable, currentField, currentDir) => {
        if (isSortable && !isLoading)
            return () => sort(currentField, currentDir);
    };

    const getCursor = isSortable => {
        if (!canSearch) return 'auto';
        if (isSortable) {
            return isLoading ? 'progress' : 'pointer';
        }
        return 'auto';
    };

    const getIcon = (isSortable, isSorted) => {
        if (!canSearch || !isSortable) return null;
        if (isSorted) {
            return prevDir === 'asc' ? (
                <i
                    className='fas fa-sort-amount-up-alt'
                    style={{ marginLeft: 10 }}
                />
            ) : (
                <i
                    className='fas fa-sort-amount-down'
                    style={{ marginLeft: 10 }}
                />
            );
        }
        return <i className='fas fa-sort ml-2' style={{ marginLeft: 10 }} />;
    };

    return (
        <TableHead>
            <TableRow className='table__header'>
                {columns.map(({ label, sortableProps }) => {
                    const isSortable = !!sortableProps;
                    const currentField = sortableProps?.field;
                    const currentDir = sortableProps?.defaultDir;
                    const isSorted = currentField === prevField;

                    if (label === 'accordion') return <TableCell key={label} />;
                    return (
                        <TableCell
                            key={label}
                            onClick={handleSort(
                                isSortable,
                                currentField,
                                currentDir
                            )}
                            style={{
                                cursor: getCursor(isSortable),
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                padding: '6px 10px',
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                }}
                            >
                                {translate(label).toUpperCase()}
                                {getIcon(isSortable, isSorted)}
                            </div>
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead>
    );
};

export default TableHeader;
